export default __webpack_public_path__ + "static/O0065-2aedcfb97c70c30caa9569f48c8edee2.png";